// extracted by mini-css-extract-plugin
export default {"shimmerWrapper":"shimmer_shimmerWrapper__pqxex","shimmer":"shimmer_shimmer__0eu5a"};